module.exports = {
    failed: 'Estas credenciales no coinciden con nuestros registros.',
    throttle: 'Demasiados intentos de inicio. Por favor intente de nuevo en  :seconds segundos.',
}